module.exports = __webpack_public_path__ + "static/t_323_717-e819f0840ee23b4484f23fd9197dae8f.png";